import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Card from '../Common/Card';
import Icon from '../Common/Icon';
import * as types from '../../constants/actionTypes';
import { actions as projectLocationActions } from '../../actions/projectLocationActions';
import { actions as baselineActions } from '../../actions/baselineActions';
import AddToScopeDrawer from '../Subscription/Admin/ProjectLocations/AddToScopeDrawer';
import LinkProjectBaselineDrawer from './LinkProjectBaselineDrawer';
import BaselineForm from '../Subscription/Admin/BaselinesForm';
export class ProjectStepGuide extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            locationsInScope: 0,
            baselinesCount: 0,
            locationsPushed: 0,
            searchBaselinesParams: {
                subscriptionId: this.props.subscriptionId,
                projectKey: this.props.projectKey,
                isActive: true,
                pageSize: 10, // Smaller default page size for table in section of PM Dashboard
                pageNumber: 1,
                sortBy: "name",
                sortDir: "asc",
                name: ""
            },
            searchProjectLocationsParamsAll: {
                projectKey: this.props.projectKey,
                isActive: true,
                isOnHold: false,
                isPushedDown: null,
                pageSize: 10,
                pageNumber: 1,
                sortBy: "locationName",
                sortDir: "asc"
            },
            searchProjectLocationsParamsPushed: {
                projectKey: this.props.projectKey,
                isActive: true,
                isOnHold: false,
                isPushedDown: true,
                pageSize: 10,
                pageNumber: 1,
                sortBy: "locationName",
                sortDir: "asc"
            },
            isAddToScopeDrawerOpen: false,
            isScopeByAttribute: false,
            isLinkExistingBaselineDrawerOpen: false,
            isAddNewBaselineDrawerOpen: false
        }
    }
    async componentDidMount() {
        await this.searchProjectBaselines();
        await this.searchProjectLocationsInScope();
        await this.searchProjectLocationsPushed();
    }

    searchProjectBaselines = async () => {
        try {
            const result = await this.props.projectMgrDashboardActions.loadProjectBaselines(this.state.searchBaselinesParams);
            if (result.type === types.LOAD_PROJECT_BASELINES_SUCCESS) {
                this.setState({ baselinesCount: result.payload.totalCount });
            } else if (result.type === types.LOAD_PROJECT_BASELINES_FAILURE) {
                Notification("error", "An Error Occurred", result.payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        }
    }

    searchProjectLocationsInScope = async () => {
        try {
            const result = await this.props.projectLocationActions.searchProjectLocations(this.state.searchProjectLocationsParamsAll);
            const payload = result.payload;
            if (result.type === types.SEARCH_PROJECTLOCATION_SUCCESS) {
                this.setState({
                    locationsInScope: payload.totalCount });
            } else if (result.type === types.SEARCH_PROJECTLOCATION_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        }
    }

    searchProjectLocationsPushed = async () => {
        try {
            const result = await this.props.projectLocationActions.searchProjectLocations(this.state.searchProjectLocationsParamsPushed);
            const payload = result.payload;
            if (result.type === types.SEARCH_PROJECTLOCATION_SUCCESS) {
                this.setState({
                    locationsPushed: payload.totalCount });
            } else if (result.type === types.SEARCH_PROJECTLOCATION_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        }
    }

    onAddScope = (isScopeByAttribute = false) => {
        this.setState({ isAddToScopeDrawerOpen: true, isScopeByAttribute: isScopeByAttribute });
    }

    onAddScopeCancel = () => {
        this.setState({ isAddToScopeDrawerOpen: false, isScopeByAttribute: false });
    }

    onAddScopeComplete = () => {
        this.setState({ isAddToScopeDrawerOpen: false, isScopeByAttribute: false }, this.searchProjectLocationsInScope);
    }

    onLinkExisting = () => {
        this.setState({ isLinkExistingBaselineDrawerOpen: true });
    }

    onLinkExistingComplete = () => {
        this.setState({ isLinkExistingBaselineDrawerOpen: false }, this.searchProjectBaselines);
        window.location.reload()
    }

    onLinkExistingCancel = () => {
        this.setState({ isLinkExistingBaselineDrawerOpen: false });
    }

    onAddNewBaseline = () => {
        this.setState({ isAddNewBaselineDrawerOpen: true });
    }

    onAddNewBaselineComplete = () => {
        this.setState({ isAddNewBaselineDrawerOpen: false },  this.searchProjectBaselines);
        window.location.reload()
    }

    onAddNewBaselineCancel = () => {
        this.setState({ isAddNewBaselineDrawerOpen: false });
    }
    
    goToProjectBaselines = () => {
        window.location = "#project-baselines-table";
    }

    render() {
        const step1 = "Step 1: Select the teams/locations who will complete the project";
        const step2 = "Step 2: Create the tasks that the teams/locations will need to complete";
        const step3 = "Step 3: Activate the project for the teams/locations";

        return (
            <div className='project-step-guide'>
                <div className='row full-size-label'>
                    <div className="col-md-4">
                        <p className='mx-3'><b>{step1}</b></p>
                    </div>
                    <div className="col-md-4">
                        <p className='mx-3'><b>{step2}</b></p>
                    </div>
                    <div className="col-md-4">
                        <p className='mx-3'><b>{step3}</b></p>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <p className='mx-3 small-screen-label'><b>{step1}</b></p>
                        <Card>
                            <div className='row mx-2'>
                                <div className="col-9 links">
                                    <div className="row">
                                        <button type="button" className="hyperlink" onClick={this.onAddScope} alt="Add locations to scope by name">
                                            <span>Add locations to scope by name</span><span className='blue-arrow ms-1'><Icon name="arrow-right" /></span>
                                        </button>
                                    </div>
                                    <div className="row">
                                        <button type="button" className="hyperlink" onClick={() => this.onAddScope(true)} alt="Add locations to scope by attribute">
                                            <span>Add locations to scope by attribute</span><span className='blue-arrow ms-1'><Icon name="arrow-right" /></span>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-3 count">
                                    <div className="row">
                                        <button type="button" className="count-number" onClick={this.props.onNavigateToProjectLocations}>
                                            {this.state.locationsInScope}
                                        </button>
                                    </div>
                                    <div className="row count-label">In Scope</div>
                                </div>
                            </div>
                        </Card>
                    </div>
                    <div className="col-md-4">
                        <p className='mx-3 small-screen-label'><b>{step2}</b></p>
                        <Card>
                            <div className='row mx-2'>
                                <div className="col-9 links">
                                    <div className="row">
                                        <button type="button" className="hyperlink" onClick={this.onLinkExisting} alt="Link Existing Baseline">
                                            <span>Link an existing baseline to this project</span><span className='blue-arrow ms-1'><Icon name="arrow-right" /></span>
                                        </button>
                                    </div>
                                    <div className="row">
                                        <button type="button" className="hyperlink" onClick={this.onAddNewBaseline} alt="Add new baseline">
                                            <span>Add a new baseline</span><span className='blue-arrow ms-1'><Icon name="arrow-right" /></span>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-3 count">
                                    <div className="row">
                                        <button type="button" className="count-number" onClick={this.goToProjectBaselines}>
                                            {this.state.baselinesCount}
                                        </button>
                                    </div>
                                    <div className="row count-label">Baselines</div>
                                </div>
                            </div>
                        </Card>
                    </div>
                    <div className="col-md-4">
                        <p className='mx-3 small-screen-label'><b>{step3}</b></p>
                        <Card>
                            <div className='row mx-2'>
                                <div className="col-9 links">
                                    <div className="row">
                                        <button type="button" className="hyperlink" onClick={this.props.onNavigateToProjectLocations} alt="Push specific locations">
                                            <span>Push specific locations or multiple dates</span><span className='blue-arrow ms-1'><Icon name="arrow-right" /></span>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-3 count">
                                    <div className="row">
                                        <button type="button" className="count-number" onClick={this.props.onNavigateToProjectLocations}>
                                            {this.state.locationsPushed}
                                        </button>
                                    </div>
                                    <div className="row count-label">Pushed</div>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
                {
                    this.state.isAddToScopeDrawerOpen &&
                    <AddToScopeDrawer
                        subscriptionId={this.props.subscriptionId}
                        projectKey={this.props.projectKey}
                        onCancel={this.onAddScopeCancel}
                        onComplete={this.onAddScopeComplete}
                        projectLocationActions={this.props.projectLocationActions} 
                        openAttributeForm={this.state.isScopeByAttribute} />
                }
                {
                    this.state.isLinkExistingBaselineDrawerOpen &&
                    <LinkProjectBaselineDrawer
                        subscriptionId={this.props.subscriptionId}
                        projectKey={this.props.projectKey}
                        projectMgrDashboardActions={this.props.projectMgrDashboardActions}
                        onComplete={this.onLinkExistingComplete}
                        onCancel={this.onLinkExistingCancel}
                    />
                }
                {
                    this.state.isAddNewBaselineDrawerOpen &&
                    <BaselineForm
                        saveClick={this.onAddNewBaselineComplete}
                        cancelClick={this.onAddNewBaselineCancel}
                        baselineActions={this.props.baselineActions}
                        projectKey={this.props.projectKey}
                        subscriptionId={this.props.subscriptionId}
                    />
                }
            </div>
        )
    }
}

ProjectStepGuide.propTypes = {
    projectMgrDashboardActions: PropTypes.object.isRequired,
    projectLocationActions: PropTypes.object.isRequired,
    baselineActions: PropTypes.object.isRequired,
    subscriptionId: PropTypes.string.isRequired,
    projectKey: PropTypes.string.isRequired,
    onNavigateToProjectLocations: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        projectLocationActions: bindActionCreators(projectLocationActions, dispatch),
        baselineActions: bindActionCreators(baselineActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(ProjectStepGuide);
